<template>
  <div class="flex flex-col sm:flex-row justify-start items-center">
    <div class="relative flex-grow">
      <Input
        :label="label"
        :aria-label="label"
        :model-value="value?.from"
        :force-label-to-top="true"
        :placeholder="placeholderFrom ?? $t('from')"
        :icon="icon"
        :step="step"
        :min="min"
        :max="max"
        :variant="variant"
        type="number"
        @update:model-value="setFrom"
      />
    </div>
    <span class="h-px w-2.5 mx-3.5 bg-element-neutral" />
    <div class="relative flex-grow">
      <Input
        :aria-label="label"
        :model-value="value?.to"
        :placeholder="placeholderTo ?? $t('to')"
        :icon="icon"
        :step="step"
        :min="min"
        :max="max"
        type="number"
        @update:model-value="setTo"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useVModel, type VueInstance } from '@vueuse/core';
import Input from '@components/utils/inputs/Input.vue';
import type { FunctionalComponent } from 'vue';
import type { Variant } from './Field.vue';

interface Props {
  modelValue: {
    from?: number;
    to?: number;
  } | null;
  label: string;
  placeholderFrom?: string;
  placeholderTo?: string;
  variant?: Variant;
  icon?: VueInstance | FunctionalComponent | string | object;
  step?: string;
  min?: string;
  max?: string;
}

const emit = defineEmits(['update:modelValue']);
const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
});

const value = useVModel(props, 'modelValue', emit, { passive: true });

const setFrom = (v: number) => {
  if (!value.value) value.value = { from: v };
  value.value = { ...value.value, from: v };
};
const setTo = (v: number) => {
  if (!value.value) value.value = { to: v };
  value.value = { ...value.value, to: v };
};
</script>
